import { dirname, resolve } from "path";
import { fileURLToPath } from "url";

const __dirname = dirname(fileURLToPath(import.meta.url));
const platformRuntimeMetrics = resolve(__dirname, "../../platform/src/runtime-metrics.ts");

const mod = await import(platformRuntimeMetrics);

export const getRuntimeMetricsSnapshot = mod.getRuntimeMetricsSnapshot;
export const startRuntimeMetricsSampler = mod.startRuntimeMetricsSampler;
